import * as React from 'react';
import { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Plus as PlusIcon } from '@phosphor-icons/react/dist/ssr/Plus';
import type User from 'benchmarking-domain/user';
import { UsersTable } from 'components/admin/users/users-table';
import useApi from 'hooks/use-api';
import { paths } from 'paths';
import { useNavigate } from 'react-router-dom';

export default function Users(): React.JSX.Element {
  const { subscribeUsers } = useApi();
  const [users, setUsers] = useState<User[]>([]);

  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = subscribeUsers(undefined, (fetchedUsers) => {
      setUsers(fetchedUsers?.sort((one, two) => ((one.name ?? one.email) < (two.name ?? two.email) ? -1 : 1)));
    });

    return () => {
      unsubscribe();
    };
  }, [subscribeUsers]);

  return (
    <Stack spacing={3}>
      <Stack direction="row" spacing={3}>
        <Stack spacing={1} sx={{ flex: '1 1 auto' }}>
          <Typography variant="h4">Users</Typography>
        </Stack>
        <div>
          <Button
            onClick={() => {
              navigate(paths.app.admin.users.add);
            }}
            startIcon={<PlusIcon fontSize="var(--icon-fontSize-md)" />}
            variant="contained"
          >
            Add
          </Button>
        </div>
      </Stack>

      <UsersTable rows={users} />
    </Stack>
  );
}
